import { Flex, Heading, Text } from '@chakra-ui/react'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import HamburgerMenu from '../HamburgerMenu/HamburgerMenu'

type HeaderProps = {}

const Header: React.FC<HeaderProps> = () => {
  const location = useLocation()

  return (
    <Flex
      bg='blue.500'
      minH='80px'
      w='100vw'
      alignItems='center'
      p={4}
      justifyContent='space-between'
    >
      <Link to='/'>
        <Heading w='min-content' fontSize='2xl'>
          Kauhavan veteraanitalo
        </Heading>
      </Link>
      <Flex gap={8} display={{ base: 'none', md: 'flex' }} fontWeight={900}>
        <Link to='/'>
          <Text
            _hover={{ textDecoration: 'underline' }}
            color={location.pathname === '/' ? 'blue.100' : 'white'}
          >
            Tietoa
          </Text>
        </Link>
        <Link to='/historia'>
          <Text
            _hover={{ textDecoration: 'underline' }}
            color={location.pathname === '/historia' ? 'blue.100' : 'white'}
          >
            Historia
          </Text>
        </Link>
        <Link to='/kuvia'>
          <Text
            _hover={{ textDecoration: 'underline' }}
            color={location.pathname === '/kuvia' ? 'blue.100' : 'white'}
          >
            Kuvia
          </Text>
        </Link>
        <Link to='/kalenteri'>
          <Text
            _hover={{ textDecoration: 'underline' }}
            color={location.pathname === '/kalenteri' ? 'blue.100' : 'white'}
          >
            Kalenteri
          </Text>
        </Link>
        <Link to='/yhteystiedot'>
          <Text
            _hover={{ textDecoration: 'underline' }}
            color={location.pathname === '/yhteystiedot' ? 'blue.100' : 'white'}
          >
            Yhteystiedot
          </Text>
        </Link>
      </Flex>
      <Flex display={{ base: 'flex', md: 'none' }}>
        <HamburgerMenu />
      </Flex>
    </Flex>
  )
}
export default Header
